<app-navbar title="Zadania">
	<button class="btn btn-info me-4" (click)="showTransfer = true"><i class="fas fa-random"></i> Przekaż</button>
	<button class="btn btn-success me-4" *ngIf="data.status === '2'" (click)="taskRestore()">
		<i class="fas fa-times"></i> Przywróć
	</button>
	<button class="btn btn-success me-4" *ngIf="data.status === '1'" (click)="taskEndShow()">
		<i class="fas fa-times"></i> Zakończ
	</button>
	<a class="btn btn-danger" routerLink="/task"> <i class="fas fa-tasks"></i> Zadania </a>
</app-navbar>

<div class="card" *ngIf="showTransfer">
	<div class="card-body">
		<h5 class="card-title">Przekazanie zadania</h5>
		<div class="card-text">
			<form (submit)="transferSave()">
				<div class="mb-3">
					<ng-select
						id="owner"
						name="owner"
						[(ngModel)]="transferToUser"
						[items]="users"
						bindLabel="name"
						bindValue="id"
						placeholder="(Wybierz)"
					></ng-select>
				</div>
				<div class="row">
					<div class="col-sm-6 d-grid">
						<button type="submit" class="btn btn-info"><i class="fas fa-random"></i> Przekaż</button>
					</div>
					<div class="col-sm-6 d-grid">
						<button class="btn btn-secondary" (click)="showTransfer = false">Anuluj</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>

<div class="card">
	<div class="card-body">
		<div class="card-text">
			<div class="row">
				<div class="col-sm-6">
					<label>Termin do:</label>
					{{ data.deadline | formatDateTime }}
				</div>
				<div class="col-sm-6">
					<label>Utworzone przez:</label>
					{{ data?.authorName }}
				</div>
				<div class="col-sm-6">
					<label>Obiekt:</label>
					{{ data?.objTypeName }} (<a routerLink="{{ data?.objLink }}">{{ data?.objId }}</a
					>)
				</div>
				<div class="col-sm-6">
					<label>Przypisane do:</label>
					{{ data?.ownerName }}
				</div>
				<div class="col-sm-12">
					<label>Treść:</label>
					<span [innerHTML]="data?.content"></span><br />
				</div>
			</div>
		</div>
	</div>
</div>
